import { render, staticRenderFns } from "./StatisticMostViewedProduct.vue?vue&type=template&id=f04556fc&scoped=true"
import script from "./StatisticMostViewedProduct.vue?vue&type=script&lang=js"
export * from "./StatisticMostViewedProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04556fc",
  null
  
)

export default component.exports